import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { Search } from "@organic-return/foundation-react/src/components/Search/Search"
import { useSiteContext } from "../common/SiteContext"
import truncate from "truncate-html"
import { WsrvImage } from "@organic-return/foundation-react/src/components/Media"
import { EWsrvTransform } from "@organic-return/foundation-react/src/lib"

const BuildersSearch = (props: any) => {
  const siteContext = useSiteContext()
  // Configurable results per page defaults to 20
  let pageSize = props.pageSize || 0
  return (
    <Search
      index={props.builders}
      pageSize={pageSize}
      showCount={true}
      renderItem={(item, index) => {
        return (
          <div key={index} className="flex flex-col gap-y-4 w-full sm:w-1/2 lg:w-1/4 xl:w-1/5 p-4">
            <Link className="bg-white" to={item.path}>
              {item.builderLogo?.url && (                
                <WsrvImage 
                  urlParams={{
                    originURL: item.builderLogo.url,
                    preset: EWsrvTransform.fill1x1,
                    width: item.builderLogo.width,
                  }}                  
                  imgProps={{
                    className: "object-contain object-center w-full",
                    wrapperClassName: "h-full w-full"

                  }}                  
                />                
              )}
            </Link>
            <h3 className="font-black text-xl uppercase leading-9 tracking-widest">{item.builderName}</h3>
            <div className="font-medium leading-7 tracking-widest" dangerouslySetInnerHTML={{ __html: truncate(item.builderDescription, 88) }}>
            </div>
            <Link
              to={item.path}
              children="View Builder"
              className="self-start font-black tracking-widest px-6 py-2 text-xs bg-accent inline-block uppercase text-body-text-inverted"
            />
          </div>
        )
      }}
      preRenderItem={(item, index) => {
        return (
          <a key={index} href={item.path}></a>
        )
      }}
      {...siteContext.buildersSearchProps}
    />
  )
}

export default BuildersSearch

export const query = graphql`
fragment DrupalBuildersSearchContent on DrupalBuildersSearch {
    id
    pageSize
    builders {
      builderDescription
      builderLogo {  
        alt            
        url        
        height
        width
      }
      builderName
      path
    }
}
`